// extracted by mini-css-extract-plugin
export var divider = "_wk-0";